var BufferList = require('bufferlist');
var util = require('../lib/util.es6');


var OrderedBufferList = BufferList.extend({
    comparator: function (bufferA, bufferB) {
        return util.naturalCompare(
            bufferA.normaliseDisplay(),
            bufferB.normaliseDisplay()
        );
    }
});


module.exports = OrderedBufferList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/orderedbufferlist.js
// module id = zICk
// module chunks = 1